module.exports = __webpack_public_path__ + "img/illustration-name.baa1e980.svg";